<template lang="pug">
canvas#grid-layer(ref="grid")
</template>

<script>
let gc
import CanvasMixin from "./CanvasMixin"
export default {
  name: "GridCanvas",
  components: {},
  mixins: [CanvasMixin],
  data() {
    return {
      showMinorTicks: this.$state.scale >= 3,
      showMajorTicks: this.$state.scale >= 2
    }
  },
  mounted() {
    this.canvasKey = "grid"
    this.onInitialize = this.initializeGrid
  },
  methods: {
    initializeGrid(ctx) {
      gc = ctx
      if (this.$state.showGrid) this.initializeBoard()
    },
    initializeBoard() {
      gc.lineWidth = 1

      let d = this.scaledTile / 12
      let h = this.height * this.scaledTile
      let w = this.width * this.scaledTile
      // override the initial values to make room for right and bottom lines
      gc.canvas.height = h + 1
      gc.canvas.width = w + 1

      // func so that x and y axis logic are the same
      let build = (gc, value, func) => {
        let tick = ""
        let o = 0

        if (value % this.scaledTile == 0) {
          gc.setLineDash([0, 0])
          tick = 3
          gc.strokeStyle = "silver"
          o = 0.5
        } else if (value % (this.scaledTile / 3) == 0) {
          gc.setLineDash([5, 2])
          tick = 2
          gc.strokeStyle = "pink"
        } else {
          gc.setLineDash([3, 3])
          tick = 1
          gc.strokeStyle = "rgba(0, 255, 255, 0.3)"
        }
        // only detail ticks if scale is big enough showing this on smaller grids will look to busy
        if ((this.showMinorTicks && tick == 1) || (this.showMajorTicks && tick == 2) || tick == 3) {
          gc.beginPath()
          func(value, o)
          gc.stroke()
        }
      }

      for (let y = 0; y <= h; y += d) {
        build(gc, y, (_y, o) => {
          gc.moveTo(0, _y + o)
          gc.lineTo(w, _y + o)
        })
      }

      for (let x = 0; x <= w; x += d) {
        build(gc, x, (_x, o) => {
          gc.moveTo(_x + o, 0)
          gc.lineTo(_x + o, h)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
